import { Alert, Table, Tag, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { platformListAllDomains } from '../api'
import type { DomainWithSite } from '../types'

const STATUS_COLOR: Record<string, string> = {
  pending: 'default',
  verification_required: 'orange',
  verified: 'blue',
  ssl_pending: 'purple',
  active: 'green',
  error: 'red',
}

export default function PlatformDomainsPage() {
  const [rows, setRows] = useState<DomainWithSite[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    platformListAllDomains()
      .then((r) => setRows(r.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false))
  }, [])

  if (error) return <Alert type="error" message={error} showIcon />

  return (
    <div>
      <Typography.Title level={4}>Domains</Typography.Title>
      <Table
        className="pf-data-table"
        rowKey="id"
        loading={loading}
        dataSource={rows}
        sticky
        columns={[
          { title: 'Hostname', dataIndex: 'hostname', align: 'left' as const },
          {
            title: 'Workspace',
            dataIndex: 'workspace_name',
            render: (name: string, row) => <Link to={`/platform/tenants/${row.workspace_id}`}>{name}</Link>,
          },
          { title: 'Site', dataIndex: 'site_name' },
          { title: 'Primary', dataIndex: 'is_primary', render: (v: boolean) => (v ? <Tag color="gold">Primary</Tag> : null) },
          {
            title: 'Status',
            dataIndex: 'status',
            render: (s: string) => <Tag color={STATUS_COLOR[s] ?? 'default'}>{s}</Tag>,
          },
        ]}
      />
    </div>
  )
}
